import { Popper, TextField, Typography } from "@mui/material";
import MuiAutocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/features/language/languageSlice";
const StyledAutocomplete = styled(MuiAutocomplete)(
  ({ theme, customEndAdornment, width }) => ({
    width: width ?? "unset",
    minWidth: "150px",
    "& .MuiInputBase-root": {
      paddingRight: customEndAdornment ? "5px" : null,
    },
    "& .MuiInput-underline:before": {
      borderBottom: "1px solid var(--main-color)",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "1px solid var(--main-color)",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
    },
    "& .MuiFilledInput-underline:before": {
      borderBottom: "1px solid var(--main-color)",
    },
    "& .MuiFilledInput-underline:after": {
      borderBottom: "1px solid var(--main-color)",
    },
    "& .MuiAutocomplete-endAdornment": {
      "& .MuiAutocomplete-clearIndicator": {
        "& .MuiSvgIcon-root": {
          fill: "var(--text-primary)",
        },
      },
      "& .MuiSvgIcon-root": {
        fill: "var(--main-color)",
      },
    },
    "& .MuiInputLabel-root": {
      color: "var(--main-color)",
      "&.Mui-focused": {
        color: "var(--main-color)",
      },
    },
  })
);
const StyledPopper = styled(Popper)(({ theme }) => ({
  ".MuiAutocomplete-listbox": {
    backgroundColor: "var(--bkg-secondary)",
    color: "var(--text-primary)",
    "& .MuiAutocomplete-option": {
      fontSize: "14px",
      padding: "8px",
      padingLeft: "14px",
      "&:hover": {
        backgroundColor: "var(--main-color)",
      },
      "&[aria-selected='true']": {
        backgroundColor: "var(--bkg-secondary)",
        color: "var(--text-primary)",
      },
    },
  },
}));

export default function AutocompleteComponent({
  options = [],
  label = "",
  size = "small",
  placeholder = "",
  primaryFocusColor,
  width,
  fullWidth,
  ...props
}) {
  const currentLanguage = useSelector(selectLanguage);
  return (
    <StyledAutocomplete
      PopperComponent={StyledPopper}
      noOptionsText={
        <Typography color="#fff" variant="body1" fontSize={"14px"}>
          {currentLanguage === "IT" ? "Nessuna opzione" : "No options found"}
        </Typography>
      }
      width={fullWidth ? "100%" : width}
      options={options}
      autoHighlight
      customEndAdornment={props.customEndAdornment}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
      {...props}
    />
  );
}
